var exports = {
  "fi": "column__aAtNRm",
  "R_": "heading__5XYjGM",
  "p_": "list__ir_4b_",
  "AS": "item__KZSU7Z",
};

module.exports = exports;
